// extracted by mini-css-extract-plugin
export var text = "_redotech-arbiter-lib-common-descriptors-text";